import React from 'react';

const ArrowDownOpen = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8" {...props}>
    <path
      fillRule="evenodd"
      d="M.722.884A.956.956 0 0 1 2.107.89L6 4.937 9.893.891a.957.957 0 0 1 1.385-.007l.034.034c.38.396.382 1.036 0 1.434L6.688 7.168a.944.944 0 0 1-1.376 0L.688 2.352a1.049 1.049 0 0 1 0-1.434L.722.884z"
    />
  </svg>
);

export default ArrowDownOpen;
